import _ from 'lodash';
import * as api from './api';
import * as yup from 'yup';
import * as helpers from 'services/helpers';

export const getContractDocumentData = async (params, accessToken?: string) => {
  try {
    let res = await api.getContractDocumentData(params, accessToken);
    return res;
  } catch (err) {
    throw err;
  }
};
